var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-navbar',{staticClass:"custom-gy",attrs:{"toggleable":"lg"}},[_c('b-navbar-brand',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../assets/images/goodyear-logo.png"),"alt":"Goodyear"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }